import { useState } from 'react';
import { Button } from '../ui';

// Sections → topics tree for the structure-first exam view. Sections are
// expanded by default; each topic row shows its question count and a
// "Browse questions" action that hands off to the question bank.
export default function ExamStructureTree({ sections, countsByTopic, onBrowseTopic }) {
  const [collapsed, setCollapsed] = useState({});
  const toggle = (sectionId) => setCollapsed((prev) => ({ ...prev, [sectionId]: !prev[sectionId] }));

  if (!sections?.length) return <div className="empty">No sections found for this exam.</div>;

  return (
    <div className="hierarchy-tree">
      {sections.map((section) => {
        const topics = section.topics || [];
        const sectionQuestions = topics.reduce((total, topic) => total + (countsByTopic[topic.id] || 0), 0);
        const open = !collapsed[section.id];
        return (
          <div key={section.id} className="hierarchy-node">
            <button className="hierarchy-toggle" onClick={() => toggle(section.id)} aria-expanded={open}>
              <span>{open ? '▾' : '▸'}</span>
              <strong>{section.title}</strong>
              <small>{topics.length} {topics.length === 1 ? 'topic' : 'topics'} · {sectionQuestions} questions</small>
            </button>
            {open && (
              <div className="hierarchy-children">
                {!topics.length ? (
                  <div className="hierarchy-leaf static">No topics in this section yet.</div>
                ) : topics.map((topic) => (
                  <div key={topic.id} className="topic-row">
                    <span className="hierarchy-bullet" />
                    <div className="topic-row-main">
                      <span className="topic-row-title">{topic.title || topic.name}</span>
                      <small>{countsByTopic[topic.id] || 0} questions</small>
                    </div>
                    <Button variant="text" onClick={() => onBrowseTopic(topic)}>Browse questions →</Button>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
